var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ThemeOne",on:{"click":function($event){return _vm.jumpUrl(_vm.ItemDate.componentForwardType)}}},[_c('img',{attrs:{"src":_vm.ItemDate.pictureAndLinkVOS[0].pic,"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3a9a154","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActivityTheme/ThemeOne.vue
// module id = null
// module chunks = 